import React, { useState } from 'react';

export default function PWAUpdatePrompt({ registration, onDismiss }) {
  const [updating, setUpdating] = useState(false);

  if (!registration) return null;

  const handleUpdate = () => {
    setUpdating(true);
    const worker = registration.waiting;
    if (worker) {
      worker.postMessage({ type: 'SKIP_WAITING' });
      // Reload once the new SW takes control
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }
  };

  return (
    <div className="fixed top-4 left-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 animate-[slideDown_0.35s_ease-out]">
      <div className="flex items-center gap-3 rounded-2xl border border-blue-200 bg-white p-4 shadow-2xl shadow-blue-900/10">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-blue-100 text-lg">
          🔄
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-black text-slate-900">Update available</p>
          <p className="text-xs text-slate-500">A new version of Vivifyer is ready.</p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            onClick={handleUpdate}
            disabled={updating}
            className="rounded-xl bg-blue-600 px-4 py-2 text-xs font-bold text-white shadow-sm transition hover:bg-blue-700 disabled:opacity-60"
          >
            {updating ? 'Updating…' : 'Update'}
          </button>
          <button
            onClick={onDismiss}
            className="flex h-7 w-7 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
            aria-label="Dismiss"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
